import React from 'react';
import { CONTACT_INFO, MANAGING_DIRECTOR, PIZZERIA_NAME } from '../constants';
import SectionHeading from './SectionHeading';

const Impressum = () => {
  return (
    <div className="section-surface section-surface-tinted">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-24">
        <SectionHeading
          eyebrow="Impressum"
          title="Anbieterkennzeichnung"
          description="Angaben gemäß § 5 DDG."
        />

        <section className="mt-12 rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
          <div className="space-y-3 text-base text-stone-700">
            <p className="text-xl font-semibold tracking-tight text-stone-950">
              {PIZZERIA_NAME}
            </p>
            <p>{CONTACT_INFO.addressLines[0]}</p>
            <p>{CONTACT_INFO.addressLines[1]}</p>

            <p className="pt-2">
              Telefon:{' '}
              <a
                href={CONTACT_INFO.phoneHref}
                className="font-semibold hover:text-orange-700"
              >
                {CONTACT_INFO.phone}
              </a>
            </p>
            <p>
              E-Mail:{' '}
              <a
                href={CONTACT_INFO.emailHref}
                className="font-semibold hover:text-orange-700"
              >
                {CONTACT_INFO.email}
              </a>
            </p>

            <p className="pt-2">
              Geschäftsführer:{' '}
              <span className="font-semibold">{MANAGING_DIRECTOR}</span>
            </p>
            <p>
              Registergericht: <span className="font-semibold">Itzehoe</span>
            </p>
            <p>
              Registernummer: <span className="font-semibold">01061029</span>
            </p>
            <p>
              Umsatzsteuer-Identifikationsnummer:{' '}
              <span className="font-semibold">DE459481731</span>
            </p>

            <p className="pt-4 text-sm leading-7 text-stone-700">
              Verbraucherstreitbeilegung: Wir sind nicht bereit und nicht
              verpflichtet, an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Impressum;
